// extracted by mini-css-extract-plugin
module.exports =  {"section":"_93444fe79c--section--UpyCR","list":"_93444fe79c--list--zOiDE","column":"_93444fe79c--column--JLwFl"};